import { render, staticRenderFns } from "./index.vue?vue&type=template&id=494fbf5e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogHeader: require('/opt/buildhome/repo/components/Blog/Header.vue').default,BlogCategorias: require('/opt/buildhome/repo/components/Blog/Categorias.vue').default,BlogCard: require('/opt/buildhome/repo/components/Blog/Card.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
